import React from 'react';
import Button from '../../../atoms/button/button';
import './mentoriaNotLogged.scss';

interface MentoriaNotLoggedProps {
    buttonAction: any;
    blobImage: any;
    alertImage: any;
}

const MentoriaNotLogged = ({ buttonAction, alertImage, blobImage }: MentoriaNotLoggedProps) => {
    return (
        <div className="mentoria-not-logged-container">
            <div className="mentoria-not-logged-container__background">
                <div className="mentoria-not-logged-container__images">
                    <img src={blobImage} alt="" className="mentoria-not-logged-container__images__blob" />
                    <img src={alertImage} alt="Alerta" className="mentoria-not-logged-container__images__alert" />
                </div>
                <h3 className="mentoria-not-logged-container__subtitle">Para comenzar la mentoria es necesario que inicies sesión</h3>
                <Button
                    type='button'
                    classname="mentoria-not-logged-container__button"
                    gtmMark='secondary'
                    text='Iniciar Sesión'
                    onClickAction={buttonAction}
                    isDisabled={false}
                />
            </div>
        </div>
    )
}

export default MentoriaNotLogged